"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _serializr = require("serializr");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _constants = require("@seedlang/constants");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _moment = _interopRequireDefault(require("moment"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _level = _interopRequireDefault(require("./level"));
var _image = _interopRequireDefault(require("./image"));
var _date_decorator = _interopRequireDefault(require("./date_decorator"));
var _user_group = _interopRequireDefault(require("./user_group"));
var _banner_notice = _interopRequireDefault(require("./banner_notice"));
var _membership = _interopRequireDefault(require("./membership"));
var _membership_type = _interopRequireDefault(require("./membership_type"));
var _membership_group = _interopRequireDefault(require("./membership_group"));
var _promotion_basic = _interopRequireDefault(require("./promotion_basic"));
var _patreon_user = _interopRequireDefault(require("./patreon_user"));
var _site = _interopRequireDefault(require("./site"));
var _target_language = _interopRequireDefault(require("./target_language"));
var _user_podcast = _interopRequireDefault(require("./user_podcast"));
var _referrer_option = _interopRequireDefault(require("./referrer_option"));
var _payment_migration = _interopRequireDefault(require("./payment_migration"));
var _privacy_settings = _interopRequireDefault(require("./privacy_settings"));
var _league = _interopRequireDefault(require("./league"));
var _user_league = _interopRequireDefault(require("./user_league"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71, _descriptor72, _descriptor73, _descriptor74, _descriptor75, _descriptor76, _descriptor77, _descriptor78, _descriptor79, _descriptor80, _descriptor81, _descriptor82, _descriptor83, _descriptor84, _descriptor85, _descriptor86, _descriptor87, _descriptor88, _descriptor89, _descriptor90, _descriptor91, _descriptor92, _descriptor93, _descriptor94, _descriptor95, _descriptor96, _descriptor97, _descriptor98, _descriptor99, _descriptor100, _descriptor101, _descriptor102, _descriptor103, _descriptor104, _descriptor105, _descriptor106, _descriptor107, _descriptor108, _descriptor109, _descriptor110, _descriptor111, _descriptor112, _descriptor113, _descriptor114, _descriptor115, _descriptor116, _descriptor117, _descriptor118, _descriptor119, _descriptor120, _descriptor121, _descriptor122, _descriptor123, _descriptor124, _descriptor125, _descriptor126, _descriptor127, _descriptor128, _descriptor129, _descriptor130, _descriptor131, _descriptor132, _descriptor133, _descriptor134, _descriptor135, _descriptor136, _descriptor137, _descriptor138, _descriptor139, _descriptor140, _descriptor141, _descriptor142, _descriptor143, _descriptor144, _descriptor145, _descriptor146, _descriptor147, _descriptor148, _descriptor149, _descriptor150, _descriptor151, _descriptor152, _descriptor153, _descriptor154, _descriptor155, _descriptor156, _descriptor157, _descriptor158, _descriptor159, _descriptor160, _descriptor161, _descriptor162, _descriptor163, _descriptor164, _descriptor165, _descriptor166, _descriptor167, _descriptor168, _descriptor169, _descriptor170, _descriptor171, _descriptor172, _descriptor173, _descriptor174, _descriptor175, _descriptor176, _descriptor177, _descriptor178, _descriptor179, _descriptor180, _descriptor181, _descriptor182, _descriptor183, _descriptor184, _descriptor185, _descriptor186, _descriptor187, _descriptor188, _descriptor189, _descriptor190, _descriptor191, _descriptor192, _descriptor193, _descriptor194, _descriptor195, _descriptor196, _descriptor197, _descriptor198, _descriptor199, _descriptor200, _descriptor201, _descriptor202, _descriptor203, _descriptor204, _descriptor205, _descriptor206, _descriptor207, _descriptor208, _descriptor209, _descriptor210, _descriptor211, _descriptor212, _descriptor213, _descriptor214, _descriptor215, _descriptor216, _descriptor217, _descriptor218, _descriptor219, _descriptor220, _descriptor221, _descriptor222, _descriptor223, _descriptor224, _descriptor225, _descriptor226, _descriptor227, _descriptor228, _descriptor229, _descriptor230, _descriptor231, _descriptor232, _descriptor233, _descriptor234, _descriptor235, _descriptor236, _descriptor237, _descriptor238, _descriptor239, _descriptor240, _descriptor241, _descriptor242, _descriptor243, _descriptor244, _descriptor245, _descriptor246, _descriptor247, _descriptor248, _descriptor249, _descriptor250, _descriptor251, _descriptor252, _descriptor253, _descriptor254, _descriptor255, _descriptor256, _descriptor257, _descriptor258, _descriptor259, _descriptor260, _descriptor261, _descriptor262, _descriptor263, _descriptor264, _descriptor265, _descriptor266, _descriptor267, _descriptor268, _descriptor269, _descriptor270, _descriptor271, _descriptor272, _descriptor273, _descriptor274, _descriptor275, _descriptor276, _descriptor277, _descriptor278, _descriptor279, _descriptor280, _descriptor281, _descriptor282, _descriptor283, _descriptor284, _descriptor285, _descriptor286, _descriptor287, _descriptor288, _descriptor289, _descriptor290, _descriptor291, _descriptor292, _descriptor293, _descriptor294, _descriptor295, _descriptor296, _descriptor297, _descriptor298, _descriptor299, _descriptor300, _descriptor301, _descriptor302, _descriptor303, _descriptor304, _descriptor305, _descriptor306, _descriptor307, _descriptor308, _descriptor309, _descriptor310, _descriptor311, _descriptor312, _descriptor313, _descriptor314, _descriptor315, _descriptor316, _descriptor317, _descriptor318, _descriptor319, _descriptor320, _descriptor321, _descriptor322, _descriptor323, _descriptor324, _descriptor325, _descriptor326, _descriptor327, _descriptor328, _descriptor329, _descriptor330, _descriptor331, _descriptor332, _descriptor333, _descriptor334, _descriptor335, _descriptor336, _descriptor337, _descriptor338, _descriptor339, _descriptor340, _descriptor341, _descriptor342, _descriptor343, _descriptor344, _descriptor345, _descriptor346, _descriptor347, _descriptor348, _descriptor349, _descriptor350, _descriptor351, _descriptor352, _descriptor353, _descriptor354, _descriptor355, _descriptor356, _descriptor357, _descriptor358, _descriptor359, _descriptor360; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var User = (_dec = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec2 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec3 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec4 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec5 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec6 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec7 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec8 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec9 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec10 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec11 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec12 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec13 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec14 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec15 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec16 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec17 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec18 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec19 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec20 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec21 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec22 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec23 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec24 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec25 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec26 = (0, _serializr.serializable)((0, _serializr.object)(_site["default"])), _dec27 = (0, _serializr.serializable)((0, _serializr.object)(_banner_notice["default"])), _dec28 = (0, _serializr.serializable)((0, _serializr.object)(_level["default"])), _dec29 = (0, _serializr.serializable)((0, _serializr.object)(_referrer_option["default"])), _dec30 = (0, _serializr.serializable)((0, _serializr.object)(_patreon_user["default"])), _dec31 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_user_group["default"]))), _dec32 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_target_language["default"]))), _dec33 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_user_podcast["default"]))), _dec34 = (0, _serializr.serializable)((0, _serializr.object)(_target_language["default"])), _dec35 = (0, _serializr.serializable)((0, _serializr.object)(_image["default"])), _dec36 = (0, _serializr.serializable)((0, _serializr.object)(_promotion_basic["default"])), _dec37 = (0, _serializr.serializable)((0, _serializr.object)(_membership["default"])), _dec38 = (0, _serializr.serializable)((0, _serializr.object)(_membership_type["default"])), _dec39 = (0, _serializr.serializable)((0, _serializr.object)(_membership_group["default"])), _dec40 = (0, _serializr.serializable)((0, _serializr.object)(_payment_migration["default"])), _dec41 = (0, _serializr.serializable)((0, _serializr.object)(_privacy_settings["default"])), _dec42 = (0, _serializr.serializable)((0, _serializr.object)(_league["default"])), _dec43 = (0, _serializr.serializable)((0, _serializr.object)(_user_league["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function User() {
    var _this;
    _classCallCheck(this, User);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, User, [].concat(args));
    // there is also a user_basic.js
    _initializerDefineProperty(_this, "successfulCheckout", _descriptor, _this);
    _initializerDefineProperty(_this, "hideTriviaNewLabel", _descriptor2, _this);
    _initializerDefineProperty(_this, "jwtToken", _descriptor3, _this);
    _initializerDefineProperty(_this, "blockUserTracking", _descriptor4, _this);
    _initializerDefineProperty(_this, "showSpecialCharacters", _descriptor5, _this);
    _initializerDefineProperty(_this, "hideEnglishPrompts", _descriptor6, _this);
    _initializerDefineProperty(_this, "reviewed1", _descriptor7, _this);
    _initializerDefineProperty(_this, "reviewed2", _descriptor8, _this);
    _initializerDefineProperty(_this, "reviewed1UserId", _descriptor9, _this);
    _initializerDefineProperty(_this, "reviewed1UserId", _descriptor10, _this);
    _initializerDefineProperty(_this, "languageForumId", _descriptor11, _this);
    _initializerDefineProperty(_this, "translatorsFilterHasTranslation", _descriptor12, _this);
    _initializerDefineProperty(_this, "textInputConjugationTrainer", _descriptor13, _this);
    _initializerDefineProperty(_this, "textInputNumberTrainer", _descriptor14, _this);
    _initializerDefineProperty(_this, "freeConjugationDecksAvailableCount", _descriptor15, _this);
    _initializerDefineProperty(_this, "conjugationCardsSeenCount", _descriptor16, _this);
    _initializerDefineProperty(_this, "conjugationDecksFinishedCount", _descriptor17, _this);
    _initializerDefineProperty(_this, "conjugationFilterPronoun", _descriptor18, _this);
    _initializerDefineProperty(_this, "conjugationFilterTense", _descriptor19, _this);
    _initializerDefineProperty(_this, "conjugationFilterIncludeSentenceCards", _descriptor20, _this);
    _initializerDefineProperty(_this, "communityBadge", _descriptor21, _this);
    _initializerDefineProperty(_this, "evaluateVocabOnKeystroke", _descriptor22, _this);
    _initializerDefineProperty(_this, "enforceCasing", _descriptor23, _this);
    _initializerDefineProperty(_this, "strictMatch", _descriptor24, _this);
    _initializerDefineProperty(_this, "reviewsListSort", _descriptor25, _this);
    _initializerDefineProperty(_this, "reviewsFilterDue", _descriptor26, _this);
    _initializerDefineProperty(_this, "reviewsFilterDifficultyScore", _descriptor27, _this);
    _initializerDefineProperty(_this, "reviewsFilterReviewsCount", _descriptor28, _this);
    _initializerDefineProperty(_this, "reviewsFilterRetired", _descriptor29, _this);
    _initializerDefineProperty(_this, "reviewsFilterCardTypeId", _descriptor30, _this);
    _initializerDefineProperty(_this, "reviewsFilterDeckId", _descriptor31, _this);
    _initializerDefineProperty(_this, "reviewsFilterCreatedAt", _descriptor32, _this);
    _initializerDefineProperty(_this, "reviewsFilterCreatedAtDaysAgo", _descriptor33, _this);
    _initializerDefineProperty(_this, "reviewsFilterReviewAfter", _descriptor34, _this);
    _initializerDefineProperty(_this, "hoursUntilFirstReview", _descriptor35, _this);
    _initializerDefineProperty(_this, "daysUntilReviewRetired", _descriptor36, _this);
    _initializerDefineProperty(_this, "disableRetiringReviews", _descriptor37, _this);
    _initializerDefineProperty(_this, "xpView", _descriptor38, _this);
    _initializerDefineProperty(_this, "mobileTextDirection", _descriptor39, _this);
    _initializerDefineProperty(_this, "duplicateEmails", _descriptor40, _this);
    _initializerDefineProperty(_this, "appleUserId", _descriptor41, _this);
    _initializerDefineProperty(_this, "countryCode", _descriptor42, _this);
    _initializerDefineProperty(_this, "vocabTab", _descriptor43, _this);
    _initializerDefineProperty(_this, "invitedToBeta", _descriptor44, _this);
    _initializerDefineProperty(_this, "appleIdEmail", _descriptor45, _this);
    _initializerDefineProperty(_this, "playStoreEmail", _descriptor46, _this);
    _initializerDefineProperty(_this, "iosAlphaTester", _descriptor47, _this);
    _initializerDefineProperty(_this, "androidAlphaTester", _descriptor48, _this);
    _initializerDefineProperty(_this, "iosBetaTester", _descriptor49, _this);
    _initializerDefineProperty(_this, "androidBetaTester", _descriptor50, _this);
    _initializerDefineProperty(_this, "androidBetaTesterExportedToCsv", _descriptor51, _this);
    _initializerDefineProperty(_this, "androidBetaTesterWrongEmail", _descriptor52, _this);
    _initializerDefineProperty(_this, "maxNumberOfVocabWords", _descriptor53, _this);
    _initializerDefineProperty(_this, "maxNumberOfGenderWords", _descriptor54, _this);
    _initializerDefineProperty(_this, "maxNumberOfPluralWords", _descriptor55, _this);
    _initializerDefineProperty(_this, "maxNumberOfConjugationWords", _descriptor56, _this);
    _initializerDefineProperty(_this, "maxNumberOfNumberWords", _descriptor57, _this);
    _initializerDefineProperty(_this, "rejectCardSubmissions", _descriptor58, _this);
    _initializerDefineProperty(_this, "onlyShowNativeLanguage", _descriptor59, _this);
    _initializerDefineProperty(_this, "siteShowsMaintenancePage", _descriptor60, _this);
    _initializerDefineProperty(_this, "versions", _descriptor61, _this);
    _initializerDefineProperty(_this, "sentenceSubmissionsCount", _descriptor62, _this);
    _initializerDefineProperty(_this, "genderCardsSeenCount", _descriptor63, _this);
    _initializerDefineProperty(_this, "numberCardsSeenCount", _descriptor64, _this);
    _initializerDefineProperty(_this, "pluralCardsSeenCount", _descriptor65, _this);
    _initializerDefineProperty(_this, "dailyReviewSummariesCount", _descriptor66, _this);
    _initializerDefineProperty(_this, "triviaQuestionsCount", _descriptor67, _this);
    _initializerDefineProperty(_this, "contentTreeDecksCount", _descriptor68, _this);
    _initializerDefineProperty(_this, "vocabTrainerWordsCount", _descriptor69, _this);
    _initializerDefineProperty(_this, "vocabTrainerNounsCount", _descriptor70, _this);
    _initializerDefineProperty(_this, "vocabTrainerVerbsCount", _descriptor71, _this);
    _initializerDefineProperty(_this, "vocabTrainerPluralsCount", _descriptor72, _this);
    _initializerDefineProperty(_this, "vocabTrainerGendersCount", _descriptor73, _this);
    _initializerDefineProperty(_this, "triviaQuestionsAnsweredCount", _descriptor74, _this);
    _initializerDefineProperty(_this, "contentTreeDecksFinishedCount", _descriptor75, _this);
    _initializerDefineProperty(_this, "vocabDecksFinishedCount", _descriptor76, _this);
    _initializerDefineProperty(_this, "genderDecksFinishedCount", _descriptor77, _this);
    _initializerDefineProperty(_this, "pluralDecksFinishedCount", _descriptor78, _this);
    _initializerDefineProperty(_this, "triviaDecksFinishedCount", _descriptor79, _this);
    _initializerDefineProperty(_this, "vocabTrainerWordsSeenCount", _descriptor80, _this);
    _initializerDefineProperty(_this, "homePageAfterOnboarding", _descriptor81, _this);
    _initializerDefineProperty(_this, "homePage", _descriptor82, _this);
    _initializerDefineProperty(_this, "setLanguagePreference", _descriptor83, _this);
    _initializerDefineProperty(_this, "translationSourcesCount", _descriptor84, _this);
    _initializerDefineProperty(_this, "banned", _descriptor85, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor86, _this);
    _initializerDefineProperty(_this, "englishPreference", _descriptor87, _this);
    _initializerDefineProperty(_this, "firstDeckWasContentTree", _descriptor88, _this);
    _initializerDefineProperty(_this, "firstDeckWasVocab", _descriptor89, _this);
    _initializerDefineProperty(_this, "firstDeckWasTrivia", _descriptor90, _this);
    _initializerDefineProperty(_this, "firstDeckId", _descriptor91, _this);
    _initializerDefineProperty(_this, "firstDeckName", _descriptor92, _this);
    _initializerDefineProperty(_this, "hasOpenedReviewDeck", _descriptor93, _this);
    _initializerDefineProperty(_this, "hasOpenedTriviaDeck", _descriptor94, _this);
    _initializerDefineProperty(_this, "hasOpenedVocabDeck", _descriptor95, _this);
    _initializerDefineProperty(_this, "hasOpenedContentTreeDeck", _descriptor96, _this);
    _initializerDefineProperty(_this, "learningPreference", _descriptor97, _this);
    _initializerDefineProperty(_this, "hideTriviaRecord", _descriptor98, _this);
    _initializerDefineProperty(_this, "availableStreakRepairsCount", _descriptor99, _this);
    _initializerDefineProperty(_this, "sampleVocabDeckId", _descriptor100, _this);
    _initializerDefineProperty(_this, "signedOut", _descriptor101, _this);
    _initializerDefineProperty(_this, "maintenanceMode", _descriptor102, _this);
    _initializerDefineProperty(_this, "patreonValidUntil", _descriptor103, _this);
    _initializerDefineProperty(_this, "id", _descriptor104, _this);
    _initializerDefineProperty(_this, "name", _descriptor105, _this);
    _initializerDefineProperty(_this, "location", _descriptor106, _this);
    _initializerDefineProperty(_this, "email", _descriptor107, _this);
    _initializerDefineProperty(_this, "confirmedEmail", _descriptor108, _this);
    _initializerDefineProperty(_this, "unconfirmedEmail", _descriptor109, _this);
    _initializerDefineProperty(_this, "paypalEmail", _descriptor110, _this);
    _initializerDefineProperty(_this, "xp", _descriptor111, _this);
    _initializerDefineProperty(_this, "xpLastWeek", _descriptor112, _this);
    _initializerDefineProperty(_this, "xpLastMonth", _descriptor113, _this);
    _initializerDefineProperty(_this, "xpLevel", _descriptor114, _this);
    _initializerDefineProperty(_this, "dailyXpGoal", _descriptor115, _this);
    _initializerDefineProperty(_this, "currentMonthXp", _descriptor116, _this);
    _initializerDefineProperty(_this, "currentDayXp", _descriptor117, _this);
    _initializerDefineProperty(_this, "admin", _descriptor118, _this);
    _initializerDefineProperty(_this, "canAccessAdminSite", _descriptor119, _this);
    _initializerDefineProperty(_this, "canAccessAdminPosts", _descriptor120, _this);
    _initializerDefineProperty(_this, "canAccessAdminUsers", _descriptor121, _this);
    _initializerDefineProperty(_this, "userDataAccessLevel", _descriptor122, _this);
    _initializerDefineProperty(_this, "moderator", _descriptor123, _this);
    _initializerDefineProperty(_this, "translator", _descriptor124, _this);
    _initializerDefineProperty(_this, "translatorType", _descriptor125, _this);
    _initializerDefineProperty(_this, "removedAsTranslator", _descriptor126, _this);
    _initializerDefineProperty(_this, "videoCreator", _descriptor127, _this);
    _initializerDefineProperty(_this, "developer", _descriptor128, _this);
    _initializerDefineProperty(_this, "flagCountry", _descriptor129, _this);
    _initializerDefineProperty(_this, "superAdmin", _descriptor130, _this);
    _initializerDefineProperty(_this, "hideOnLeaderboard", _descriptor131, _this);
    _initializerDefineProperty(_this, "timeZone", _descriptor132, _this);
    _initializerDefineProperty(_this, "decksCount", _descriptor133, _this);
    _initializerDefineProperty(_this, "answerFeedEntryCount", _descriptor134, _this);
    _initializerDefineProperty(_this, "storyFeedEntryCount", _descriptor135, _this);
    _initializerDefineProperty(_this, "finishedUserDecksCount", _descriptor136, _this);
    _initializerDefineProperty(_this, "facebookImageUrl", _descriptor137, _this);
    _initializerDefineProperty(_this, "followersCount", _descriptor138, _this);
    _initializerDefineProperty(_this, "followingsCount", _descriptor139, _this);
    _initializerDefineProperty(_this, "levelId", _descriptor140, _this);
    _initializerDefineProperty(_this, "esLevelId", _descriptor141, _this);
    _initializerDefineProperty(_this, "deLevelId", _descriptor142, _this);
    _initializerDefineProperty(_this, "frLevelId", _descriptor143, _this);
    _initializerDefineProperty(_this, "introduction", _descriptor144, _this);
    _initializerDefineProperty(_this, "userGroupsCount", _descriptor145, _this);
    _initializerDefineProperty(_this, "currentStreakCount", _descriptor146, _this);
    _initializerDefineProperty(_this, "deckSegmentsCompletedCount", _descriptor147, _this);
    _initializerDefineProperty(_this, "reviewCardsCompletedCount", _descriptor148, _this);
    _initializerDefineProperty(_this, "unseenNotificationsCount", _descriptor149, _this);
    _initializerDefineProperty(_this, "mobileUnseenNotificationsCount", _descriptor150, _this);
    _initializerDefineProperty(_this, "followedByMe", _descriptor151, _this);
    _initializerDefineProperty(_this, "onboarded", _descriptor152, _this);
    _initializerDefineProperty(_this, "userGroupsCount", _descriptor153, _this);
    _initializerDefineProperty(_this, "purposeOfAccount", _descriptor154, _this);
    _initializerDefineProperty(_this, "uiElementsSeen", _descriptor155, _this);
    _initializerDefineProperty(_this, "sessionsCount", _descriptor156, _this);
    _initializerDefineProperty(_this, "feedEntryCount", _descriptor157, _this);
    _initializerDefineProperty(_this, "reviewCardsCount", _descriptor158, _this);
    _initializerDefineProperty(_this, "chatMessageCount", _descriptor159, _this);
    _initializerDefineProperty(_this, "correctionCount", _descriptor160, _this);
    _initializerDefineProperty(_this, "notificationsCount", _descriptor161, _this);
    _initializerDefineProperty(_this, "pastDueReviewCardsCount", _descriptor162, _this);
    _initializerDefineProperty(_this, "blockMailingByType", _descriptor163, _this);
    _initializerDefineProperty(_this, "blockAllMailings", _descriptor164, _this);
    _initializerDefineProperty(_this, "currentStreakActive", _descriptor165, _this);
    _initializerDefineProperty(_this, "teamPageBio", _descriptor166, _this);
    _initializerDefineProperty(_this, "teamPageOrder", _descriptor167, _this);
    _initializerDefineProperty(_this, "teamPageTitle", _descriptor168, _this);
    _initializerDefineProperty(_this, "todaysDate", _descriptor169, _this);
    _initializerDefineProperty(_this, "todaysDatetime", _descriptor170, _this);
    _initializerDefineProperty(_this, "userDecksCount", _descriptor171, _this);
    _initializerDefineProperty(_this, "showBetaFeatures", _descriptor172, _this);
    _initializerDefineProperty(_this, "blockMediaAccess", _descriptor173, _this);
    _initializerDefineProperty(_this, "stripeCustomerId", _descriptor174, _this);
    _initializerDefineProperty(_this, "currency", _descriptor175, _this);
    _initializerDefineProperty(_this, "affiliateCode", _descriptor176, _this);
    _initializerDefineProperty(_this, "ipAddress", _descriptor177, _this);
    _initializerDefineProperty(_this, "credits", _descriptor178, _this);
    _initializerDefineProperty(_this, "teamMember", _descriptor179, _this);
    _initializerDefineProperty(_this, "hideDeckProgress", _descriptor180, _this);
    _initializerDefineProperty(_this, "hideHighlight", _descriptor181, _this);
    _initializerDefineProperty(_this, "permanentMembership", _descriptor182, _this);
    _initializerDefineProperty(_this, "temporaryFreeMembership", _descriptor183, _this);
    _initializerDefineProperty(_this, "mobilePaymentWithoutReceipt", _descriptor184, _this);
    _initializerDefineProperty(_this, "guest", _descriptor185, _this);
    _initializerDefineProperty(_this, "pendingGuestDecision", _descriptor186, _this);
    _initializerDefineProperty(_this, "convertedFromGuest", _descriptor187, _this);
    _initializerDefineProperty(_this, "listeningComprehensionMode", _descriptor188, _this);
    _initializerDefineProperty(_this, "simpleTextMode", _descriptor189, _this);
    _initializerDefineProperty(_this, "subscriptionsCount", _descriptor190, _this);
    _initializerDefineProperty(_this, "contractedModules", _descriptor191, _this);
    _initializerDefineProperty(_this, "loopSupplement", _descriptor192, _this);
    _initializerDefineProperty(_this, "paymentProblems", _descriptor193, _this);
    _initializerDefineProperty(_this, "supplementMaximized", _descriptor194, _this);
    _initializerDefineProperty(_this, "points", _descriptor195, _this);
    _initializerDefineProperty(_this, "enterNewPassword", _descriptor196, _this);
    _initializerDefineProperty(_this, "vocabCardAudio", _descriptor197, _this);
    _initializerDefineProperty(_this, "vocabCardAudioRemember", _descriptor198, _this);
    _initializerDefineProperty(_this, "confirmed", _descriptor199, _this);
    _initializerDefineProperty(_this, "confirmedAt", _descriptor200, _this);
    _initializerDefineProperty(_this, "xpRankingTotal", _descriptor201, _this);
    _initializerDefineProperty(_this, "xpRankingLastWeek", _descriptor202, _this);
    _initializerDefineProperty(_this, "xpRankingLastMonth", _descriptor203, _this);
    _initializerDefineProperty(_this, "commentOrdering", _descriptor204, _this);
    _initializerDefineProperty(_this, "discount", _descriptor205, _this);
    _initializerDefineProperty(_this, "defaultTriviaLevel", _descriptor206, _this);
    _initializerDefineProperty(_this, "triviaGamesWon", _descriptor207, _this);
    _initializerDefineProperty(_this, "triviaGamesLost", _descriptor208, _this);
    _initializerDefineProperty(_this, "triviaGamesTied", _descriptor209, _this);
    _initializerDefineProperty(_this, "triviaPoints", _descriptor210, _this);
    _initializerDefineProperty(_this, "triviaPointsLastWeek", _descriptor211, _this);
    _initializerDefineProperty(_this, "triviaPointsLastMonth", _descriptor212, _this);
    _initializerDefineProperty(_this, "triviaPointsRankingTotal", _descriptor213, _this);
    _initializerDefineProperty(_this, "triviaPointsRankingLastWeek", _descriptor214, _this);
    _initializerDefineProperty(_this, "triviaPointsRankingLastMonth", _descriptor215, _this);
    _initializerDefineProperty(_this, "followAssociationId", _descriptor216, _this);
    _initializerDefineProperty(_this, "freeGamesAvailableCount", _descriptor217, _this);
    _initializerDefineProperty(_this, "freeGenderDecksAvailableCount", _descriptor218, _this);
    _initializerDefineProperty(_this, "freePluralDecksAvailableCount", _descriptor219, _this);
    _initializerDefineProperty(_this, "freeConjugationDecksAvailableCount", _descriptor220, _this);
    _initializerDefineProperty(_this, "freeNumberDecksAvailableCount", _descriptor221, _this);
    _initializerDefineProperty(_this, "freeVocabDecksAvailableCount", _descriptor222, _this);
    _initializerDefineProperty(_this, "numberOfDaysBeforePro", _descriptor223, _this);
    _initializerDefineProperty(_this, "numberOfDecksOpenedBeforePro", _descriptor224, _this);
    _initializerDefineProperty(_this, "numberOfDecksFinishedBeforePro", _descriptor225, _this);
    _initializerDefineProperty(_this, "paymentOption", _descriptor226, _this);
    _initializerDefineProperty(_this, "viewedCheckoutCount", _descriptor227, _this);
    _initializerDefineProperty(_this, "learnedCount", _descriptor228, _this);
    _initializerDefineProperty(_this, "retiredCount", _descriptor229, _this);
    _initializerDefineProperty(_this, "maxReviewCardsCount", _descriptor230, _this);
    _initializerDefineProperty(_this, "vocabReviewing", _descriptor231, _this);
    _initializerDefineProperty(_this, "vocabSeen", _descriptor232, _this);
    _initializerDefineProperty(_this, "targetLanguageId", _descriptor233, _this);
    _initializerDefineProperty(_this, "vocabLevelId", _descriptor234, _this);
    _initializerDefineProperty(_this, "vocabWordTypeId", _descriptor235, _this);
    _initializerDefineProperty(_this, "vocabLearned", _descriptor236, _this);
    _initializerDefineProperty(_this, "vocabHasSentence", _descriptor237, _this);
    _initializerDefineProperty(_this, "vocabSearchQuery", _descriptor238, _this);
    _initializerDefineProperty(_this, "vocabSort", _descriptor239, _this);
    _initializerDefineProperty(_this, "vocabSortDirection", _descriptor240, _this);
    _initializerDefineProperty(_this, "vocabLanguagesEnable", _descriptor241, _this);
    _initializerDefineProperty(_this, "vocabLanguagesLanguageId", _descriptor242, _this);
    _initializerDefineProperty(_this, "vocabLanguagesWithWithout", _descriptor243, _this);
    _initializerDefineProperty(_this, "vocabExpandTranslation", _descriptor244, _this);
    _initializerDefineProperty(_this, "vocabAdvancedFilters", _descriptor245, _this);
    _initializerDefineProperty(_this, "vocabHasHighlightedVocabTriad", _descriptor246, _this);
    _initializerDefineProperty(_this, "hideDataSaverModal", _descriptor247, _this);
    _initializerDefineProperty(_this, "patreonUserEmail", _descriptor248, _this);
    _initializerDefineProperty(_this, "moderationActionCounts", _descriptor249, _this);
    _initializerDefineProperty(_this, "showCardAnimation", _descriptor250, _this);
    _initializerDefineProperty(_this, "showCoinAnimation", _descriptor251, _this);
    _initializerDefineProperty(_this, "showEnrichedSentences", _descriptor252, _this);
    _initializerDefineProperty(_this, "displayDeckDebugInfo", _descriptor253, _this);
    _initializerDefineProperty(_this, "browserSpeed", _descriptor254, _this);
    _initializerDefineProperty(_this, "lastWebVersionDownloaded", _descriptor255, _this);
    _initializerDefineProperty(_this, "lastMobileVersionDownloaded", _descriptor256, _this);
    _initializerDefineProperty(_this, "lastIosVersionDownloaded", _descriptor257, _this);
    _initializerDefineProperty(_this, "lastAndroidVersionDownloaded", _descriptor258, _this);
    _initializerDefineProperty(_this, "lastEsIosVersionDownloaded", _descriptor259, _this);
    _initializerDefineProperty(_this, "lastEsAndroidVersionDownloaded", _descriptor260, _this);
    _initializerDefineProperty(_this, "lastFrIosVersionDownloaded", _descriptor261, _this);
    _initializerDefineProperty(_this, "lastFrAndroidVersionDownloaded", _descriptor262, _this);
    _initializerDefineProperty(_this, "lastAllIosVersionDownloaded", _descriptor263, _this);
    _initializerDefineProperty(_this, "lastAllAndroidVersionDownloaded", _descriptor264, _this);
    _initializerDefineProperty(_this, "showUpdateBanner", _descriptor265, _this);
    _initializerDefineProperty(_this, "showAdminTools", _descriptor266, _this);
    _initializerDefineProperty(_this, "useSoundEffects", _descriptor267, _this);
    _initializerDefineProperty(_this, "useHaptics", _descriptor268, _this);
    _initializerDefineProperty(_this, "disableAndroidKeyboardSuggestions", _descriptor269, _this);
    _initializerDefineProperty(_this, "autoHideComments", _descriptor270, _this);
    _initializerDefineProperty(_this, "masculineGenderColor", _descriptor271, _this);
    _initializerDefineProperty(_this, "neuterGenderColor", _descriptor272, _this);
    _initializerDefineProperty(_this, "feminineGenderColor", _descriptor273, _this);
    _initializerDefineProperty(_this, "acceptedProMeetupRsvp", _descriptor274, _this);
    _initializerDefineProperty(_this, "acceptedTranslatorMeetupRsvp", _descriptor275, _this);
    _initializerDefineProperty(_this, "reviewsFilterDifficultyLabel", _descriptor276, _this);
    _initializerDefineProperty(_this, "showDeckArrowBox", _descriptor277, _this);
    _initializerDefineProperty(_this, "hideVocabTargetUntilRevealed", _descriptor278, _this);
    _initializerDefineProperty(_this, "showedAppUpdateAndroid", _descriptor279, _this);
    _initializerDefineProperty(_this, "showedAppUpdateIos", _descriptor280, _this);
    _initializerDefineProperty(_this, "triviamasterCount", _descriptor281, _this);
    _initializerDefineProperty(_this, "vocabmasterCount", _descriptor282, _this);
    _initializerDefineProperty(_this, "gendermasterCount", _descriptor283, _this);
    _initializerDefineProperty(_this, "deviceSignedUpWith", _descriptor284, _this);
    _initializerDefineProperty(_this, "pluralmasterCount", _descriptor285, _this);
    _initializerDefineProperty(_this, "promptForPassword", _descriptor286, _this);
    _initializerDefineProperty(_this, "hideAlreadySeenWordsMessage", _descriptor287, _this);
    _initializerDefineProperty(_this, "experiment", _descriptor288, _this);
    _initializerDefineProperty(_this, "conjugationFilterSeen", _descriptor289, _this);
    _initializerDefineProperty(_this, "genderFilterSeen", _descriptor290, _this);
    _initializerDefineProperty(_this, "pluralFilterSeen", _descriptor291, _this);
    _initializerDefineProperty(_this, "numberFilterSeen", _descriptor292, _this);
    _initializerDefineProperty(_this, "showVocabReviewSettings", _descriptor293, _this);
    _initializerDefineProperty(_this, "convertCardSubmissions", _descriptor294, _this);
    _initializerDefineProperty(_this, "contactedForInterview", _descriptor295, _this);
    _initializerDefineProperty(_this, "languageSignedUpWith", _descriptor296, _this);
    _initializerDefineProperty(_this, "showAllWorksheetVocab", _descriptor297, _this);
    _initializerDefineProperty(_this, "tagIds", _descriptor298, _this);
    _initializerDefineProperty(_this, "worksheetSort", _descriptor299, _this);
    _initializerDefineProperty(_this, "hideYoutubeVideo", _descriptor300, _this);
    _initializerDefineProperty(_this, "hidePodcastPlayer", _descriptor301, _this);
    _initializerDefineProperty(_this, "hideWorksheetDescription", _descriptor302, _this);
    _initializerDefineProperty(_this, "simplifiedTriviaDecks", _descriptor303, _this);
    _initializerDefineProperty(_this, "dismissedBannerNotice", _descriptor304, _this);
    _initializerDefineProperty(_this, "role", _descriptor305, _this);
    _initializerDefineProperty(_this, "siteId", _descriptor306, _this);
    _initializerDefineProperty(_this, "streakExtendGoal", _descriptor307, _this);
    _initializerDefineProperty(_this, "streakExtensionIsAllowed", _descriptor308, _this);
    _initializerDefineProperty(_this, "streakCanBeExtended", _descriptor309, _this);
    _initializerDefineProperty(_this, "enableStreakExtension", _descriptor310, _this);
    _initializerDefineProperty(_this, "showNativeLanguageFirst", _descriptor311, _this);
    _initializerDefineProperty(_this, "iosVideoPlayer", _descriptor312, _this);
    _initializerDefineProperty(_this, "androidVideoPlayer", _descriptor313, _this);
    _initializerDefineProperty(_this, "iosAllowVideoOverlap", _descriptor314, _this);
    _initializerDefineProperty(_this, "webAllowVideoOverlap", _descriptor315, _this);
    _initializerDefineProperty(_this, "androidAllowVideoOverlap", _descriptor316, _this);
    _initializerDefineProperty(_this, "previousStreakCount", _descriptor317, _this);
    _initializerDefineProperty(_this, "isPro", _descriptor318, _this);
    _initializerDefineProperty(_this, "lastVisitedTriviaAt", _descriptor319, _this);
    _initializerDefineProperty(_this, "lastCampaignMailerAt", _descriptor320, _this);
    _initializerDefineProperty(_this, "memberUntil", _descriptor321, _this);
    _initializerDefineProperty(_this, "lastDeckInteractionAt", _descriptor322, _this);
    _initializerDefineProperty(_this, "updatedAt", _descriptor323, _this);
    _initializerDefineProperty(_this, "createdAt", _descriptor324, _this);
    _initializerDefineProperty(_this, "lastActiveAt", _descriptor325, _this);
    _initializerDefineProperty(_this, "lastWebActiveAt", _descriptor326, _this);
    _initializerDefineProperty(_this, "lastMobileActiveAt", _descriptor327, _this);
    _initializerDefineProperty(_this, "lastAndroidActiveAt", _descriptor328, _this);
    _initializerDefineProperty(_this, "lastIosActiveAt", _descriptor329, _this);
    _initializerDefineProperty(_this, "lastEsAndroidActiveAt", _descriptor330, _this);
    _initializerDefineProperty(_this, "lastEsIosActiveAt", _descriptor331, _this);
    _initializerDefineProperty(_this, "lastFrAndroidActiveAt", _descriptor332, _this);
    _initializerDefineProperty(_this, "lastFrIosActiveAt", _descriptor333, _this);
    _initializerDefineProperty(_this, "lastAllAndroidActiveAt", _descriptor334, _this);
    _initializerDefineProperty(_this, "lastAllIosActiveAt", _descriptor335, _this);
    _initializerDefineProperty(_this, "lastCampaignMailerAt", _descriptor336, _this);
    _initializerDefineProperty(_this, "cancelAt", _descriptor337, _this);
    _initializerDefineProperty(_this, "lastStreakRepairedAt", _descriptor338, _this);
    _initializerDefineProperty(_this, "lastStreakExtendedAt", _descriptor339, _this);
    _initializerDefineProperty(_this, "translatorAssignedAt", _descriptor340, _this);
    _initializerDefineProperty(_this, "currentStreakStart", _descriptor341, _this);
    _initializerDefineProperty(_this, "currentStreakEnd", _descriptor342, _this);
    _initializerDefineProperty(_this, "site", _descriptor343, _this);
    _initializerDefineProperty(_this, "bannerNotice", _descriptor344, _this);
    _initializerDefineProperty(_this, "level", _descriptor345, _this);
    _initializerDefineProperty(_this, "referrerOption", _descriptor346, _this);
    _initializerDefineProperty(_this, "patreonUser", _descriptor347, _this);
    _initializerDefineProperty(_this, "userGroups", _descriptor348, _this);
    _initializerDefineProperty(_this, "targetLanguages", _descriptor349, _this);
    _initializerDefineProperty(_this, "userPodcasts", _descriptor350, _this);
    _initializerDefineProperty(_this, "defaultTargetLanguage", _descriptor351, _this);
    _initializerDefineProperty(_this, "image", _descriptor352, _this);
    _initializerDefineProperty(_this, "signedUpWithPromotion", _descriptor353, _this);
    _initializerDefineProperty(_this, "membership", _descriptor354, _this);
    _initializerDefineProperty(_this, "membershipType", _descriptor355, _this);
    _initializerDefineProperty(_this, "membershipGroup", _descriptor356, _this);
    _initializerDefineProperty(_this, "paymentMigration", _descriptor357, _this);
    _initializerDefineProperty(_this, "privacySettings", _descriptor358, _this);
    _initializerDefineProperty(_this, "currentLeague", _descriptor359, _this);
    _initializerDefineProperty(_this, "lastUserLeague", _descriptor360, _this);
    return _this;
  }
  _inherits(User, _RootModel);
  return _createClass(User, [{
    key: "pro",
    get: function get() {
      return this.hasMembershipType && this.membershipType.slug === 'pro';
    }
  }, {
    key: "useBritishEnglish",
    get: function get() {
      return this.englishPreference === 'uk';
    }
  }, {
    key: "streakRepairIsAvailable",
    get: function get() {
      var _this$lastStreakRepai, _this$lastStreakRepai2;
      return (0, _utils.isBlank)(this.lastStreakRepairedAt) || ((_this$lastStreakRepai = this.lastStreakRepairedAt) === null || _this$lastStreakRepai === void 0 || (_this$lastStreakRepai = _this$lastStreakRepai.date) === null || _this$lastStreakRepai === void 0 ? void 0 : _this$lastStreakRepai.getMonth()) !== new Date().getMonth() || ((_this$lastStreakRepai2 = this.lastStreakRepairedAt) === null || _this$lastStreakRepai2 === void 0 || (_this$lastStreakRepai2 = _this$lastStreakRepai2.date) === null || _this$lastStreakRepai2 === void 0 ? void 0 : _this$lastStreakRepai2.getYear()) !== new Date().getYear();
    }
  }, {
    key: "webReleaseUpToDate",
    get: function get() {
      return this.site && this.lastWebVersionDownloaded === this.site.currentWebVersion;
    }
  }, {
    key: "targetLanguagesWithXpCount",
    get: function get() {
      return this.targetLanguages.filter(function (item) {
        return item.xp > 0;
      }).length;
    }
  }, {
    key: "translatorRole",
    get: function get() {
      if (this.leadTranslator) {
        return '👑Translator Lead';
      } else if (this.trialTranslator) {
        return "\uD83D\uDC76Trial Translator(".concat(this.translationSourcesCount >= 30 ? 'Under Review' : 'Pending', ")");
      } else if (this.translator) {
        return '🚀Translator';
      }
      return 'Not a Translator';
    }
  }, {
    key: "blockedTranslationInput",
    get: function get() {
      return this.trialTranslator && this.translationSourcesCount >= 30;
    }
  }, {
    key: "trialTranslator",
    get: function get() {
      return this.translator && this.translatorType === 1;
    }
  }, {
    key: "leadTranslator",
    get: function get() {
      return this.translator && this.translatorType === 3;
    }
  }, {
    key: "fullTranslator",
    get: function get() {
      return this.translator && this.translatorType === 2;
    }
  }, {
    key: "adminOrLeadTranslator",
    get: function get() {
      return this.admin || this.leadTranslator;
    }
  }, {
    key: "adminOrTranslator",
    get: function get() {
      return this.admin || this.leadTranslator || this.fullTranslator;
    }
  }, {
    key: "anyAdmin",
    get: function get() {
      return this.admin || (0, _utils.isPresent)(this.userGroups.find(function (item) {
        return item.admin;
      }));
    }
  }, {
    key: "isAdminForSite",
    value: function isAdminForSite(siteId) {
      var _this$userGroups$find;
      return (_this$userGroups$find = this.userGroups.find(function (item) {
        var _item$group;
        return ((_item$group = item.group) === null || _item$group === void 0 ? void 0 : _item$group.siteId) === siteId;
      })) === null || _this$userGroups$find === void 0 ? void 0 : _this$userGroups$find.admin;
    }
  }, {
    key: "showWebReleaseBanner",
    get: function get() {
      return this.webVersionDownloadedWithoutRevision < this.currentWebVersionWithoutRevision;
    }
  }, {
    key: "webVersionDownloadedWithoutRevision",
    get: function get() {
      if ((0, _utils.isPresent)(this.lastWebVersionDownloaded)) {
        var ary = this.lastWebVersionDownloaded.split('.');
        ary.pop();
        return ary.join('.');
      }
      return null;
    }
  }, {
    key: "rightToLeftLanguage",
    get: function get() {
      return _constants.Constants.RTL_LANGUAGE_IDS.indexOf(this.languageId) !== -1;
    }
  }, {
    key: "currentWebVersionWithoutRevision",
    get: function get() {
      if ((0, _utils.isPresent)(this.site) && (0, _utils.isPresent)(this.site.currentWebVersion)) {
        var ary = this.site.currentWebVersion.split('.');
        ary.pop();
        return ary.join('.');
      }
      return null;
    }
  }, {
    key: "canUpdateRecords",
    get: function get() {
      var _this$currentUserGrou;
      return (_this$currentUserGrou = this.currentUserGroup) === null || _this$currentUserGrou === void 0 ? void 0 : _this$currentUserGrou.canUpdateRecords;
    }
  }, {
    key: "canDeleteRecords",
    get: function get() {
      var _this$currentUserGrou2;
      return (_this$currentUserGrou2 = this.currentUserGroup) === null || _this$currentUserGrou2 === void 0 ? void 0 : _this$currentUserGrou2.canDeleteRecords;
    }
  }, {
    key: "hideEnglishTranslations",
    get: function get() {
      return this.languageId !== 'EN' && this.onlyShowNativeLanguage;
    }
  }, {
    key: "createdWithinLastWeek",
    get: function get() {
      return this.createdAt && (0, _moment["default"])(Date.now()).subtract(1, 'week').isBefore(this.createdAt.date);
    }
  }, {
    key: "todaysDateMoment",
    get: function get() {
      return (0, _moment["default"])(new Date(this.todaysDate));
    }
  }, {
    key: "tomorrowsDate",
    get: function get() {
      return this.todaysDateMoment.add(1, 'day').toDate();
    }
  }, {
    key: "tomorrowsDateMoment",
    get: function get() {
      return (0, _moment["default"])(this.tomorrowsDate);
    }
  }, {
    key: "languageName",
    get: function get() {
      return _constants.Languages[this.language];
    }
  }, {
    key: "registered",
    get: function get() {
      return !this.signedOut && (!this.guest || this.convertedFromGuest);
    }
  }, {
    key: "premiumIsActive",
    get: function get() {
      return (0, _utils.isPresent)(this.memberUntil) && this.memberUntil.date > new Date();
    }
  }, {
    key: "membershipTypeId",
    get: function get() {
      return (0, _utils.isPresent)(this.membershipType) ? this.membershipType.id : null;
    }
  }, {
    key: "distanceFromXpGoal",
    get: function get() {
      return this.dailyXpGoal - this.currentDayXp;
    }
  }, {
    key: "activePatreonMember",
    get: function get() {
      return this.permanentPatreonMember || this.hasGroup && this.patreonUser && this.patreonUser.isPatreonActive;
    }
  }, {
    key: "permanentPatreonMember",
    get: function get() {
      var _this$easyGermanGroup;
      return (_this$easyGermanGroup = this.easyGermanGroup) === null || _this$easyGermanGroup === void 0 ? void 0 : _this$easyGermanGroup.permanent;
    }
  }, {
    key: "hasGroup",
    get: function get() {
      return (0, _utils.isPresent)(this.userGroups);
    }
  }, {
    key: "userContentGroup",
    get: function get() {
      return this.userGroups.find(function (item) {
        var _item$group2;
        return ((_item$group2 = item.group) === null || _item$group2 === void 0 ? void 0 : _item$group2.groupType) === 'content-creator';
      }) || {};
    }
  }, {
    key: "contentGroup",
    get: function get() {
      var _this$userGroups$find2;
      return ((_this$userGroups$find2 = this.userGroups.find(function (item) {
        var _item$group3;
        return ((_item$group3 = item.group) === null || _item$group3 === void 0 ? void 0 : _item$group3.groupType) === 'content-creator';
      })) === null || _this$userGroups$find2 === void 0 ? void 0 : _this$userGroups$find2.group) || {};
    }
  }, {
    key: "easyGermanGroup",
    get: function get() {
      return this.userGroups.find(function (item) {
        var _item$group4;
        return ((_item$group4 = item.group) === null || _item$group4 === void 0 ? void 0 : _item$group4.id) === _constants.Constants.EASY_GERMAN_GROUP_ID;
      });
    }
  }, {
    key: "easyGermanGroupId",
    get: function get() {
      var _this$easyGermanGroup2;
      return (_this$easyGermanGroup2 = this.easyGermanGroup) === null || _this$easyGermanGroup2 === void 0 ? void 0 : _this$easyGermanGroup2.id;
    }
  }, {
    key: "classroomGroup",
    get: function get() {
      var _this$userGroups$find3;
      return ((_this$userGroups$find3 = this.userGroups.find(function (item) {
        var _item$group5;
        return ((_item$group5 = item.group) === null || _item$group5 === void 0 ? void 0 : _item$group5.groupType) === 'classroom';
      })) === null || _this$userGroups$find3 === void 0 ? void 0 : _this$userGroups$find3.group) || {};
    }
  }, {
    key: "hasContentGroup",
    get: function get() {
      return (0, _utils.isPresent)(this.contentGroup);
    }
  }, {
    key: "hasEasyGermanGroup",
    get: function get() {
      return (0, _utils.isPresent)(this.easyGermanGroup);
    }
  }, {
    key: "hasClassroomGroup",
    get: function get() {
      return (0, _utils.isPresent)(this.classroomGroup);
    }
  }, {
    key: "hasMembershipType",
    get: function get() {
      return (0, _utils.isPresent)((0, _mobx.toJS)(this.membershipType));
    }
  }, {
    key: "hasPermanentGroupMembership",
    get: function get() {
      return this.currentGroupMembership && this.currentGroupMembership.permanent;
    }
  }, {
    key: "currentUserGroup",
    get: function get() {
      var _this$site,
        _this2 = this;
      if (((_this$site = this.site) === null || _this$site === void 0 ? void 0 : _this$site.id) === _constants.Constants.EASY_GERMAN_SITE_ID) {
        return this.userGroups.find(function (item) {
          var _item$group6;
          return ((_item$group6 = item.group) === null || _item$group6 === void 0 ? void 0 : _item$group6.id) === _constants.Constants.EASY_GERMAN_GROUP_ID;
        });
      }
      return this.userGroups.find(function (item) {
        var _item$group7, _this2$site;
        return ((_item$group7 = item.group) === null || _item$group7 === void 0 ? void 0 : _item$group7.siteId) === ((_this2$site = _this2.site) === null || _this2$site === void 0 ? void 0 : _this2$site.id);
      });
    }
  }, {
    key: "currentGroupMembership",
    get: function get() {
      var _this$site2,
        _this3 = this;
      if (((_this$site2 = this.site) === null || _this$site2 === void 0 ? void 0 : _this$site2.id) === _constants.Constants.EASY_GERMAN_SITE_ID) {
        return this.userGroups.find(function (item) {
          var _item$group8;
          return ((_item$group8 = item.group) === null || _item$group8 === void 0 ? void 0 : _item$group8.id) === _constants.Constants.EASY_GERMAN_GROUP_ID && ((0, _utils.isPresent)(item.membershipTypeId) || item.permanent);
        });
      }
      return this.userGroups.find(function (item) {
        var _item$group9, _this3$site, _this3$site2, _item$group10;
        return (((_item$group9 = item.group) === null || _item$group9 === void 0 ? void 0 : _item$group9.siteId) === ((_this3$site = _this3.site) === null || _this3$site === void 0 ? void 0 : _this3$site.id) || ((_this3$site2 = _this3.site) === null || _this3$site2 === void 0 ? void 0 : _this3$site2.isDefault) && ((_item$group10 = item.group) === null || _item$group10 === void 0 ? void 0 : _item$group10.id) === _constants.Constants.EASY_GERMAN_GROUP_ID) && ((0, _utils.isPresent)(item.membershipTypeId) || item.permanent);
      });
    }
  }, {
    key: "currentGroupMembershipType",
    get: function get() {
      var _this$userGroups$find4,
        _this4 = this;
      return (_this$userGroups$find4 = this.userGroups.find(function (item) {
        var _item$group11, _this4$site;
        return ((_item$group11 = item.group) === null || _item$group11 === void 0 ? void 0 : _item$group11.siteId) === ((_this4$site = _this4.site) === null || _this4$site === void 0 ? void 0 : _this4$site.id);
      })) === null || _this$userGroups$find4 === void 0 ? void 0 : _this$userGroups$find4.membershipType;
    }
  }, {
    key: "hasProMembershipOnSeedlang",
    get: function get() {
      var _this$site3, _this$membershipType;
      return (((_this$site3 = this.site) === null || _this$site3 === void 0 ? void 0 : _this$site3.isDefault) || (0, _utils.isBlank)(this.site)) && this.hasMembershipType && ((_this$membershipType = this.membershipType) === null || _this$membershipType === void 0 ? void 0 : _this$membershipType.slug) === 'pro';
    }
  }, {
    key: "hasPermanentMembershipOnSeedlang",
    get: function get() {
      var _this$site4;
      return ((_this$site4 = this.site) === null || _this$site4 === void 0 ? void 0 : _this$site4.isDefault) && this.permanentMembership;
    }
  }, {
    key: "hasPermanentMembershipOnWhiteLabelSite",
    get: function get() {
      var _this$site5, _this$currentUserGrou3;
      return !((_this$site5 = this.site) !== null && _this$site5 !== void 0 && _this$site5.isDefault) && ((_this$currentUserGrou3 = this.currentUserGroup) === null || _this$currentUserGrou3 === void 0 ? void 0 : _this$currentUserGrou3.permanent);
    }
  }, {
    key: "isMember",
    get: function get() {
      return this.anyAdmin || this.successfulCheckout || this.hasPermanentMembershipOnSeedlang || this.hasProMembershipOnSeedlang || (0, _utils.isPresent)(this.currentGroupMembership) || this.hasPermanentMembershipOnWhiteLabelSite;
    }
  }, {
    key: "hasOneGroup",
    get: function get() {
      return this.userGroups.length === 1;
    }
  }, {
    key: "contentGroupId",
    get: function get() {
      var _this$contentGroup;
      return (_this$contentGroup = this.contentGroup) === null || _this$contentGroup === void 0 ? void 0 : _this$contentGroup.id;
    }
  }, {
    key: "classroomGroupId",
    get: function get() {
      var _this$classroomGroup;
      return (_this$classroomGroup = this.classroomGroup) === null || _this$classroomGroup === void 0 ? void 0 : _this$classroomGroup.id;
    }
  }, {
    key: "imageUrl",
    get: function get() {
      if ((0, _utils.isPresent)(this.image) && (0, _utils.isPresent)(this.image.url)) {
        return this.image.url;
      }
      return null;
    }
  }, {
    key: "usesFacebookImage",
    get: function get() {
      return (0, _utils.isBlank)(this.image) && (0, _utils.isPresent)(this.facebookImageUrl);
    }
  }, {
    key: "hasLevel",
    get: function get() {
      return (0, _utils.isPresent)(this.level) && (0, _utils.isPresent)(this.level.id);
    }
  }, {
    key: "levelName",
    get: function get() {
      return this.hasLevel ? this.level.nameWithAbbreviation : null;
    }
  }, {
    key: "levelAbbreviation",
    get: function get() {
      return this.hasLevel ? this.level.abbreviation || 'N' : null;
    }
  }, {
    key: "firstName",
    get: function get() {
      if ((0, _utils.isPresent)(this.name)) {
        return this.name.split(' ')[0];
      }
      return 'Guest';
    }
  }, {
    key: "nativeSpeaker",
    get: function get() {
      return this.level && this.level.name === 'Native Speaker';
    }
  }, {
    key: "title",
    get: function get() {
      if (this.admin) {
        return 'Seedlang Admin';
      }
      if (this.translator) {
        return 'Seedlang Translator';
      }
      if (this.moderator) {
        return 'Seedlang Moderator';
      }
      if (this.pro) {
        return 'Seedlang Pro';
      }
      return null;
    }
  }, {
    key: "badgeLevels",
    get: function get() {
      var _this5 = this;
      return _constants.Constants.BADGES.map(function (item) {
        return item.levels.findIndex(function (currentNum) {
          return _this5[item.field] < currentNum;
        });
      });
    }
  }, {
    key: "badgeLevelCounts",
    get: function get() {
      return (0, _lodash.groupBy)(this.badgeLevels);
    }
  }, {
    key: "resetUnseenNotifications",
    value: function resetUnseenNotifications() {
      this.unseenNotificationsCount = 0;
    }
  }, {
    key: "resetMobileUnseenNotifications",
    value: function resetMobileUnseenNotifications() {
      this.mobileUnseenNotificationsCount = 0;
    }
  }, {
    key: "setCurrency",
    value: function setCurrency(currency) {
      this.currency = currency;
    }
  }, {
    key: "wasUiElementSeen",
    value: function wasUiElementSeen(uiElement) {
      return (0, _utils.isPresent)(this.uiElementsSeen) && (0, _utils.isPresent)(this.uiElementsSeen.match(uiElement));
    }
  }, {
    key: "targetLanguageById",
    get: function get() {
      return (0, _lodash.keyBy)(this.targetLanguages, 'languageId');
    }
  }, {
    key: "designateUiElementAsSeen",
    value: function designateUiElementAsSeen(uiElement) {
      if (!this.wasUiElementSeen(uiElement)) {
        var ary = (0, _utils.isPresent)(this.uiElementsSeen) ? this.uiElementsSeen.split(',') : [];
        ary.push(uiElement);
        this.uiElementsSeen = ary.join(',');
      }
    }
  }, {
    key: "moduleIsContracted",
    value: function moduleIsContracted(module) {
      return (0, _utils.isPresent)(this.contractedModules) && this.contractedModules.split(',').includes(module);
    }
  }, {
    key: "inGroup",
    value: function inGroup(groupId) {
      return (0, _utils.isPresent)(this.userGroups.find(function (item) {
        var _item$group12;
        return ((_item$group12 = item.group) === null || _item$group12 === void 0 ? void 0 : _item$group12.id) === groupId;
      }));
    }
  }, {
    key: "incrementVocabReviewCounts",
    value: function incrementVocabReviewCounts() {
      this.pastDueVocabReviewCardsCount += 1;
      this.vocabReviewCardsCount += 1;
    }
  }, {
    key: "decrementVocabReviewCounts",
    value: function decrementVocabReviewCounts() {
      this.pastDueVocabReviewCardsCount -= 1;
      this.vocabReviewCardsCount -= 1;
    }
  }, {
    key: "currencySymbol",
    get: function get() {
      var _this$currency;
      return ((_this$currency = this.currency) === null || _this$currency === void 0 ? void 0 : _this$currency.toUpperCase()) === 'USD' ? '$' : '€';
    }
  }, {
    key: "deckTypesOpened",
    get: function get() {
      var ary = [];
      if (this.hasOpenedContentTreeDeck) {
        ary.push('content tree');
      }
      if (this.hasOpenedVocabDeck) {
        ary.push('vocab');
      }
      if (this.hasOpenedTriviaDeck) {
        ary.push('trivia');
      }
      if (this.hasOpenedReviewDeck) {
        ary.push('review');
      }
      return ary.join(', ');
    }
  }, {
    key: "incrementXp",
    value: function incrementXp(amount) {
      if (amount > 0) {
        this.xp += amount;
        this.currentDayXp += amount;
      }
    }
  }, {
    key: "currentUserLeague",
    get: function get() {
      var _this$currentLeague,
        _this6 = this;
      return (_this$currentLeague = this.currentLeague) === null || _this$currentLeague === void 0 || (_this$currentLeague = _this$currentLeague.userLeagues) === null || _this$currentLeague === void 0 ? void 0 : _this$currentLeague.find(function (userLeague) {
        return userLeague.user.id === _this6.id;
      });
    }
  }, {
    key: "currentLeagueRank",
    get: function get() {
      var _this$currentUserLeag;
      return (_this$currentUserLeag = this.currentUserLeague) === null || _this$currentUserLeag === void 0 ? void 0 : _this$currentUserLeag.rank;
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "successfulCheckout", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "hideTriviaNewLabel", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "jwtToken", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "blockUserTracking", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showSpecialCharacters", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hideEnglishPrompts", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "reviewed1", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "reviewed2", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "reviewed1UserId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "reviewed1UserId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "languageForumId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "translatorsFilterHasTranslation", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "textInputConjugationTrainer", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "textInputNumberTrainer", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "freeConjugationDecksAvailableCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "conjugationCardsSeenCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "conjugationDecksFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "conjugationFilterPronoun", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "conjugationFilterTense", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "conjugationFilterIncludeSentenceCards", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "communityBadge", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "evaluateVocabOnKeystroke", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "enforceCasing", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "strictMatch", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "reviewsListSort", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterDue", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterDifficultyScore", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterReviewsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterRetired", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterCardTypeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterDeckId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterCreatedAt", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterCreatedAtDaysAgo", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterReviewAfter", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "hoursUntilFirstReview", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "daysUntilReviewRetired", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "disableRetiringReviews", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "xpView", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "mobileTextDirection", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "duplicateEmails", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "appleUserId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "countryCode", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "vocabTab", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "invitedToBeta", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "appleIdEmail", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "playStoreEmail", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "iosAlphaTester", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "androidAlphaTester", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "iosBetaTester", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "androidBetaTester", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "androidBetaTesterExportedToCsv", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "androidBetaTesterWrongEmail", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "maxNumberOfVocabWords", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "maxNumberOfGenderWords", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "maxNumberOfPluralWords", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "maxNumberOfConjugationWords", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "maxNumberOfNumberWords", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "rejectCardSubmissions", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "onlyShowNativeLanguage", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "siteShowsMaintenancePage", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "versions", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "sentenceSubmissionsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "genderCardsSeenCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "numberCardsSeenCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "pluralCardsSeenCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "dailyReviewSummariesCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "triviaQuestionsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor68 = _applyDecoratedDescriptor(_class.prototype, "contentTreeDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor69 = _applyDecoratedDescriptor(_class.prototype, "vocabTrainerWordsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor70 = _applyDecoratedDescriptor(_class.prototype, "vocabTrainerNounsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor71 = _applyDecoratedDescriptor(_class.prototype, "vocabTrainerVerbsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor72 = _applyDecoratedDescriptor(_class.prototype, "vocabTrainerPluralsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor73 = _applyDecoratedDescriptor(_class.prototype, "vocabTrainerGendersCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor74 = _applyDecoratedDescriptor(_class.prototype, "triviaQuestionsAnsweredCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor75 = _applyDecoratedDescriptor(_class.prototype, "contentTreeDecksFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor76 = _applyDecoratedDescriptor(_class.prototype, "vocabDecksFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor77 = _applyDecoratedDescriptor(_class.prototype, "genderDecksFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor78 = _applyDecoratedDescriptor(_class.prototype, "pluralDecksFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor79 = _applyDecoratedDescriptor(_class.prototype, "triviaDecksFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor80 = _applyDecoratedDescriptor(_class.prototype, "vocabTrainerWordsSeenCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor81 = _applyDecoratedDescriptor(_class.prototype, "homePageAfterOnboarding", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor82 = _applyDecoratedDescriptor(_class.prototype, "homePage", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor83 = _applyDecoratedDescriptor(_class.prototype, "setLanguagePreference", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor84 = _applyDecoratedDescriptor(_class.prototype, "translationSourcesCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor85 = _applyDecoratedDescriptor(_class.prototype, "banned", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor86 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor87 = _applyDecoratedDescriptor(_class.prototype, "englishPreference", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor88 = _applyDecoratedDescriptor(_class.prototype, "firstDeckWasContentTree", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor89 = _applyDecoratedDescriptor(_class.prototype, "firstDeckWasVocab", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor90 = _applyDecoratedDescriptor(_class.prototype, "firstDeckWasTrivia", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor91 = _applyDecoratedDescriptor(_class.prototype, "firstDeckId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor92 = _applyDecoratedDescriptor(_class.prototype, "firstDeckName", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor93 = _applyDecoratedDescriptor(_class.prototype, "hasOpenedReviewDeck", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor94 = _applyDecoratedDescriptor(_class.prototype, "hasOpenedTriviaDeck", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor95 = _applyDecoratedDescriptor(_class.prototype, "hasOpenedVocabDeck", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor96 = _applyDecoratedDescriptor(_class.prototype, "hasOpenedContentTreeDeck", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor97 = _applyDecoratedDescriptor(_class.prototype, "learningPreference", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor98 = _applyDecoratedDescriptor(_class.prototype, "hideTriviaRecord", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor99 = _applyDecoratedDescriptor(_class.prototype, "availableStreakRepairsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor100 = _applyDecoratedDescriptor(_class.prototype, "sampleVocabDeckId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor101 = _applyDecoratedDescriptor(_class.prototype, "signedOut", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor102 = _applyDecoratedDescriptor(_class.prototype, "maintenanceMode", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor103 = _applyDecoratedDescriptor(_class.prototype, "patreonValidUntil", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor104 = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor105 = _applyDecoratedDescriptor(_class.prototype, "name", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor106 = _applyDecoratedDescriptor(_class.prototype, "location", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor107 = _applyDecoratedDescriptor(_class.prototype, "email", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor108 = _applyDecoratedDescriptor(_class.prototype, "confirmedEmail", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor109 = _applyDecoratedDescriptor(_class.prototype, "unconfirmedEmail", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor110 = _applyDecoratedDescriptor(_class.prototype, "paypalEmail", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor111 = _applyDecoratedDescriptor(_class.prototype, "xp", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor112 = _applyDecoratedDescriptor(_class.prototype, "xpLastWeek", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor113 = _applyDecoratedDescriptor(_class.prototype, "xpLastMonth", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor114 = _applyDecoratedDescriptor(_class.prototype, "xpLevel", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor115 = _applyDecoratedDescriptor(_class.prototype, "dailyXpGoal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor116 = _applyDecoratedDescriptor(_class.prototype, "currentMonthXp", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor117 = _applyDecoratedDescriptor(_class.prototype, "currentDayXp", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor118 = _applyDecoratedDescriptor(_class.prototype, "admin", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor119 = _applyDecoratedDescriptor(_class.prototype, "canAccessAdminSite", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor120 = _applyDecoratedDescriptor(_class.prototype, "canAccessAdminPosts", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor121 = _applyDecoratedDescriptor(_class.prototype, "canAccessAdminUsers", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor122 = _applyDecoratedDescriptor(_class.prototype, "userDataAccessLevel", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor123 = _applyDecoratedDescriptor(_class.prototype, "moderator", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor124 = _applyDecoratedDescriptor(_class.prototype, "translator", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor125 = _applyDecoratedDescriptor(_class.prototype, "translatorType", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor126 = _applyDecoratedDescriptor(_class.prototype, "removedAsTranslator", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor127 = _applyDecoratedDescriptor(_class.prototype, "videoCreator", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor128 = _applyDecoratedDescriptor(_class.prototype, "developer", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor129 = _applyDecoratedDescriptor(_class.prototype, "flagCountry", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor130 = _applyDecoratedDescriptor(_class.prototype, "superAdmin", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor131 = _applyDecoratedDescriptor(_class.prototype, "hideOnLeaderboard", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor132 = _applyDecoratedDescriptor(_class.prototype, "timeZone", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor133 = _applyDecoratedDescriptor(_class.prototype, "decksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor134 = _applyDecoratedDescriptor(_class.prototype, "answerFeedEntryCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor135 = _applyDecoratedDescriptor(_class.prototype, "storyFeedEntryCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor136 = _applyDecoratedDescriptor(_class.prototype, "finishedUserDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor137 = _applyDecoratedDescriptor(_class.prototype, "facebookImageUrl", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor138 = _applyDecoratedDescriptor(_class.prototype, "followersCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor139 = _applyDecoratedDescriptor(_class.prototype, "followingsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor140 = _applyDecoratedDescriptor(_class.prototype, "levelId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor141 = _applyDecoratedDescriptor(_class.prototype, "esLevelId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor142 = _applyDecoratedDescriptor(_class.prototype, "deLevelId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor143 = _applyDecoratedDescriptor(_class.prototype, "frLevelId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor144 = _applyDecoratedDescriptor(_class.prototype, "introduction", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor145 = _applyDecoratedDescriptor(_class.prototype, "userGroupsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor146 = _applyDecoratedDescriptor(_class.prototype, "currentStreakCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor147 = _applyDecoratedDescriptor(_class.prototype, "deckSegmentsCompletedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor148 = _applyDecoratedDescriptor(_class.prototype, "reviewCardsCompletedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor149 = _applyDecoratedDescriptor(_class.prototype, "unseenNotificationsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor150 = _applyDecoratedDescriptor(_class.prototype, "mobileUnseenNotificationsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor151 = _applyDecoratedDescriptor(_class.prototype, "followedByMe", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor152 = _applyDecoratedDescriptor(_class.prototype, "onboarded", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor153 = _applyDecoratedDescriptor(_class.prototype, "userGroupsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor154 = _applyDecoratedDescriptor(_class.prototype, "purposeOfAccount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor155 = _applyDecoratedDescriptor(_class.prototype, "uiElementsSeen", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor156 = _applyDecoratedDescriptor(_class.prototype, "sessionsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor157 = _applyDecoratedDescriptor(_class.prototype, "feedEntryCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor158 = _applyDecoratedDescriptor(_class.prototype, "reviewCardsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor159 = _applyDecoratedDescriptor(_class.prototype, "chatMessageCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor160 = _applyDecoratedDescriptor(_class.prototype, "correctionCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor161 = _applyDecoratedDescriptor(_class.prototype, "notificationsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor162 = _applyDecoratedDescriptor(_class.prototype, "pastDueReviewCardsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor163 = _applyDecoratedDescriptor(_class.prototype, "blockMailingByType", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor164 = _applyDecoratedDescriptor(_class.prototype, "blockAllMailings", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor165 = _applyDecoratedDescriptor(_class.prototype, "currentStreakActive", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor166 = _applyDecoratedDescriptor(_class.prototype, "teamPageBio", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor167 = _applyDecoratedDescriptor(_class.prototype, "teamPageOrder", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor168 = _applyDecoratedDescriptor(_class.prototype, "teamPageTitle", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor169 = _applyDecoratedDescriptor(_class.prototype, "todaysDate", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor170 = _applyDecoratedDescriptor(_class.prototype, "todaysDatetime", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor171 = _applyDecoratedDescriptor(_class.prototype, "userDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor172 = _applyDecoratedDescriptor(_class.prototype, "showBetaFeatures", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor173 = _applyDecoratedDescriptor(_class.prototype, "blockMediaAccess", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor174 = _applyDecoratedDescriptor(_class.prototype, "stripeCustomerId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor175 = _applyDecoratedDescriptor(_class.prototype, "currency", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor176 = _applyDecoratedDescriptor(_class.prototype, "affiliateCode", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor177 = _applyDecoratedDescriptor(_class.prototype, "ipAddress", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor178 = _applyDecoratedDescriptor(_class.prototype, "credits", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor179 = _applyDecoratedDescriptor(_class.prototype, "teamMember", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor180 = _applyDecoratedDescriptor(_class.prototype, "hideDeckProgress", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor181 = _applyDecoratedDescriptor(_class.prototype, "hideHighlight", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor182 = _applyDecoratedDescriptor(_class.prototype, "permanentMembership", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor183 = _applyDecoratedDescriptor(_class.prototype, "temporaryFreeMembership", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor184 = _applyDecoratedDescriptor(_class.prototype, "mobilePaymentWithoutReceipt", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor185 = _applyDecoratedDescriptor(_class.prototype, "guest", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor186 = _applyDecoratedDescriptor(_class.prototype, "pendingGuestDecision", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor187 = _applyDecoratedDescriptor(_class.prototype, "convertedFromGuest", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor188 = _applyDecoratedDescriptor(_class.prototype, "listeningComprehensionMode", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor189 = _applyDecoratedDescriptor(_class.prototype, "simpleTextMode", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor190 = _applyDecoratedDescriptor(_class.prototype, "subscriptionsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor191 = _applyDecoratedDescriptor(_class.prototype, "contractedModules", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor192 = _applyDecoratedDescriptor(_class.prototype, "loopSupplement", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor193 = _applyDecoratedDescriptor(_class.prototype, "paymentProblems", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor194 = _applyDecoratedDescriptor(_class.prototype, "supplementMaximized", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor195 = _applyDecoratedDescriptor(_class.prototype, "points", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor196 = _applyDecoratedDescriptor(_class.prototype, "enterNewPassword", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor197 = _applyDecoratedDescriptor(_class.prototype, "vocabCardAudio", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor198 = _applyDecoratedDescriptor(_class.prototype, "vocabCardAudioRemember", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor199 = _applyDecoratedDescriptor(_class.prototype, "confirmed", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor200 = _applyDecoratedDescriptor(_class.prototype, "confirmedAt", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor201 = _applyDecoratedDescriptor(_class.prototype, "xpRankingTotal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor202 = _applyDecoratedDescriptor(_class.prototype, "xpRankingLastWeek", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor203 = _applyDecoratedDescriptor(_class.prototype, "xpRankingLastMonth", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor204 = _applyDecoratedDescriptor(_class.prototype, "commentOrdering", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor205 = _applyDecoratedDescriptor(_class.prototype, "discount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor206 = _applyDecoratedDescriptor(_class.prototype, "defaultTriviaLevel", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor207 = _applyDecoratedDescriptor(_class.prototype, "triviaGamesWon", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor208 = _applyDecoratedDescriptor(_class.prototype, "triviaGamesLost", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor209 = _applyDecoratedDescriptor(_class.prototype, "triviaGamesTied", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor210 = _applyDecoratedDescriptor(_class.prototype, "triviaPoints", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor211 = _applyDecoratedDescriptor(_class.prototype, "triviaPointsLastWeek", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor212 = _applyDecoratedDescriptor(_class.prototype, "triviaPointsLastMonth", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor213 = _applyDecoratedDescriptor(_class.prototype, "triviaPointsRankingTotal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor214 = _applyDecoratedDescriptor(_class.prototype, "triviaPointsRankingLastWeek", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor215 = _applyDecoratedDescriptor(_class.prototype, "triviaPointsRankingLastMonth", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor216 = _applyDecoratedDescriptor(_class.prototype, "followAssociationId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor217 = _applyDecoratedDescriptor(_class.prototype, "freeGamesAvailableCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor218 = _applyDecoratedDescriptor(_class.prototype, "freeGenderDecksAvailableCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor219 = _applyDecoratedDescriptor(_class.prototype, "freePluralDecksAvailableCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor220 = _applyDecoratedDescriptor(_class.prototype, "freeConjugationDecksAvailableCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor221 = _applyDecoratedDescriptor(_class.prototype, "freeNumberDecksAvailableCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor222 = _applyDecoratedDescriptor(_class.prototype, "freeVocabDecksAvailableCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor223 = _applyDecoratedDescriptor(_class.prototype, "numberOfDaysBeforePro", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor224 = _applyDecoratedDescriptor(_class.prototype, "numberOfDecksOpenedBeforePro", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor225 = _applyDecoratedDescriptor(_class.prototype, "numberOfDecksFinishedBeforePro", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor226 = _applyDecoratedDescriptor(_class.prototype, "paymentOption", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor227 = _applyDecoratedDescriptor(_class.prototype, "viewedCheckoutCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor228 = _applyDecoratedDescriptor(_class.prototype, "learnedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor229 = _applyDecoratedDescriptor(_class.prototype, "retiredCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor230 = _applyDecoratedDescriptor(_class.prototype, "maxReviewCardsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor231 = _applyDecoratedDescriptor(_class.prototype, "vocabReviewing", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor232 = _applyDecoratedDescriptor(_class.prototype, "vocabSeen", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor233 = _applyDecoratedDescriptor(_class.prototype, "targetLanguageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor234 = _applyDecoratedDescriptor(_class.prototype, "vocabLevelId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor235 = _applyDecoratedDescriptor(_class.prototype, "vocabWordTypeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor236 = _applyDecoratedDescriptor(_class.prototype, "vocabLearned", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor237 = _applyDecoratedDescriptor(_class.prototype, "vocabHasSentence", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor238 = _applyDecoratedDescriptor(_class.prototype, "vocabSearchQuery", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor239 = _applyDecoratedDescriptor(_class.prototype, "vocabSort", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor240 = _applyDecoratedDescriptor(_class.prototype, "vocabSortDirection", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor241 = _applyDecoratedDescriptor(_class.prototype, "vocabLanguagesEnable", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor242 = _applyDecoratedDescriptor(_class.prototype, "vocabLanguagesLanguageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor243 = _applyDecoratedDescriptor(_class.prototype, "vocabLanguagesWithWithout", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor244 = _applyDecoratedDescriptor(_class.prototype, "vocabExpandTranslation", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor245 = _applyDecoratedDescriptor(_class.prototype, "vocabAdvancedFilters", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor246 = _applyDecoratedDescriptor(_class.prototype, "vocabHasHighlightedVocabTriad", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor247 = _applyDecoratedDescriptor(_class.prototype, "hideDataSaverModal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor248 = _applyDecoratedDescriptor(_class.prototype, "patreonUserEmail", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor249 = _applyDecoratedDescriptor(_class.prototype, "moderationActionCounts", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor250 = _applyDecoratedDescriptor(_class.prototype, "showCardAnimation", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor251 = _applyDecoratedDescriptor(_class.prototype, "showCoinAnimation", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor252 = _applyDecoratedDescriptor(_class.prototype, "showEnrichedSentences", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor253 = _applyDecoratedDescriptor(_class.prototype, "displayDeckDebugInfo", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor254 = _applyDecoratedDescriptor(_class.prototype, "browserSpeed", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor255 = _applyDecoratedDescriptor(_class.prototype, "lastWebVersionDownloaded", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor256 = _applyDecoratedDescriptor(_class.prototype, "lastMobileVersionDownloaded", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor257 = _applyDecoratedDescriptor(_class.prototype, "lastIosVersionDownloaded", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor258 = _applyDecoratedDescriptor(_class.prototype, "lastAndroidVersionDownloaded", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor259 = _applyDecoratedDescriptor(_class.prototype, "lastEsIosVersionDownloaded", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor260 = _applyDecoratedDescriptor(_class.prototype, "lastEsAndroidVersionDownloaded", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor261 = _applyDecoratedDescriptor(_class.prototype, "lastFrIosVersionDownloaded", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor262 = _applyDecoratedDescriptor(_class.prototype, "lastFrAndroidVersionDownloaded", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor263 = _applyDecoratedDescriptor(_class.prototype, "lastAllIosVersionDownloaded", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor264 = _applyDecoratedDescriptor(_class.prototype, "lastAllAndroidVersionDownloaded", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor265 = _applyDecoratedDescriptor(_class.prototype, "showUpdateBanner", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor266 = _applyDecoratedDescriptor(_class.prototype, "showAdminTools", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor267 = _applyDecoratedDescriptor(_class.prototype, "useSoundEffects", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor268 = _applyDecoratedDescriptor(_class.prototype, "useHaptics", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor269 = _applyDecoratedDescriptor(_class.prototype, "disableAndroidKeyboardSuggestions", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor270 = _applyDecoratedDescriptor(_class.prototype, "autoHideComments", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor271 = _applyDecoratedDescriptor(_class.prototype, "masculineGenderColor", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor272 = _applyDecoratedDescriptor(_class.prototype, "neuterGenderColor", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor273 = _applyDecoratedDescriptor(_class.prototype, "feminineGenderColor", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor274 = _applyDecoratedDescriptor(_class.prototype, "acceptedProMeetupRsvp", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor275 = _applyDecoratedDescriptor(_class.prototype, "acceptedTranslatorMeetupRsvp", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor276 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterDifficultyLabel", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor277 = _applyDecoratedDescriptor(_class.prototype, "showDeckArrowBox", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor278 = _applyDecoratedDescriptor(_class.prototype, "hideVocabTargetUntilRevealed", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor279 = _applyDecoratedDescriptor(_class.prototype, "showedAppUpdateAndroid", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor280 = _applyDecoratedDescriptor(_class.prototype, "showedAppUpdateIos", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor281 = _applyDecoratedDescriptor(_class.prototype, "triviamasterCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor282 = _applyDecoratedDescriptor(_class.prototype, "vocabmasterCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor283 = _applyDecoratedDescriptor(_class.prototype, "gendermasterCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor284 = _applyDecoratedDescriptor(_class.prototype, "deviceSignedUpWith", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor285 = _applyDecoratedDescriptor(_class.prototype, "pluralmasterCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor286 = _applyDecoratedDescriptor(_class.prototype, "promptForPassword", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor287 = _applyDecoratedDescriptor(_class.prototype, "hideAlreadySeenWordsMessage", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor288 = _applyDecoratedDescriptor(_class.prototype, "experiment", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor289 = _applyDecoratedDescriptor(_class.prototype, "conjugationFilterSeen", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor290 = _applyDecoratedDescriptor(_class.prototype, "genderFilterSeen", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor291 = _applyDecoratedDescriptor(_class.prototype, "pluralFilterSeen", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor292 = _applyDecoratedDescriptor(_class.prototype, "numberFilterSeen", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor293 = _applyDecoratedDescriptor(_class.prototype, "showVocabReviewSettings", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor294 = _applyDecoratedDescriptor(_class.prototype, "convertCardSubmissions", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor295 = _applyDecoratedDescriptor(_class.prototype, "contactedForInterview", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor296 = _applyDecoratedDescriptor(_class.prototype, "languageSignedUpWith", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor297 = _applyDecoratedDescriptor(_class.prototype, "showAllWorksheetVocab", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor298 = _applyDecoratedDescriptor(_class.prototype, "tagIds", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor299 = _applyDecoratedDescriptor(_class.prototype, "worksheetSort", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor300 = _applyDecoratedDescriptor(_class.prototype, "hideYoutubeVideo", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor301 = _applyDecoratedDescriptor(_class.prototype, "hidePodcastPlayer", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor302 = _applyDecoratedDescriptor(_class.prototype, "hideWorksheetDescription", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor303 = _applyDecoratedDescriptor(_class.prototype, "simplifiedTriviaDecks", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor304 = _applyDecoratedDescriptor(_class.prototype, "dismissedBannerNotice", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor305 = _applyDecoratedDescriptor(_class.prototype, "role", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor306 = _applyDecoratedDescriptor(_class.prototype, "siteId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor307 = _applyDecoratedDescriptor(_class.prototype, "streakExtendGoal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor308 = _applyDecoratedDescriptor(_class.prototype, "streakExtensionIsAllowed", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor309 = _applyDecoratedDescriptor(_class.prototype, "streakCanBeExtended", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor310 = _applyDecoratedDescriptor(_class.prototype, "enableStreakExtension", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor311 = _applyDecoratedDescriptor(_class.prototype, "showNativeLanguageFirst", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor312 = _applyDecoratedDescriptor(_class.prototype, "iosVideoPlayer", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor313 = _applyDecoratedDescriptor(_class.prototype, "androidVideoPlayer", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor314 = _applyDecoratedDescriptor(_class.prototype, "iosAllowVideoOverlap", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor315 = _applyDecoratedDescriptor(_class.prototype, "webAllowVideoOverlap", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor316 = _applyDecoratedDescriptor(_class.prototype, "androidAllowVideoOverlap", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor317 = _applyDecoratedDescriptor(_class.prototype, "previousStreakCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor318 = _applyDecoratedDescriptor(_class.prototype, "isPro", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor319 = _applyDecoratedDescriptor(_class.prototype, "lastVisitedTriviaAt", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor320 = _applyDecoratedDescriptor(_class.prototype, "lastCampaignMailerAt", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor321 = _applyDecoratedDescriptor(_class.prototype, "memberUntil", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor322 = _applyDecoratedDescriptor(_class.prototype, "lastDeckInteractionAt", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor323 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor324 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_mobx.observable, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor325 = _applyDecoratedDescriptor(_class.prototype, "lastActiveAt", [_mobx.observable, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor326 = _applyDecoratedDescriptor(_class.prototype, "lastWebActiveAt", [_mobx.observable, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor327 = _applyDecoratedDescriptor(_class.prototype, "lastMobileActiveAt", [_mobx.observable, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor328 = _applyDecoratedDescriptor(_class.prototype, "lastAndroidActiveAt", [_mobx.observable, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor329 = _applyDecoratedDescriptor(_class.prototype, "lastIosActiveAt", [_mobx.observable, _dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor330 = _applyDecoratedDescriptor(_class.prototype, "lastEsAndroidActiveAt", [_mobx.observable, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor331 = _applyDecoratedDescriptor(_class.prototype, "lastEsIosActiveAt", [_mobx.observable, _dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor332 = _applyDecoratedDescriptor(_class.prototype, "lastFrAndroidActiveAt", [_mobx.observable, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor333 = _applyDecoratedDescriptor(_class.prototype, "lastFrIosActiveAt", [_mobx.observable, _dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor334 = _applyDecoratedDescriptor(_class.prototype, "lastAllAndroidActiveAt", [_mobx.observable, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor335 = _applyDecoratedDescriptor(_class.prototype, "lastAllIosActiveAt", [_mobx.observable, _dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor336 = _applyDecoratedDescriptor(_class.prototype, "lastCampaignMailerAt", [_mobx.observable, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor337 = _applyDecoratedDescriptor(_class.prototype, "cancelAt", [_mobx.observable, _dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor338 = _applyDecoratedDescriptor(_class.prototype, "lastStreakRepairedAt", [_mobx.observable, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor339 = _applyDecoratedDescriptor(_class.prototype, "lastStreakExtendedAt", [_mobx.observable, _dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor340 = _applyDecoratedDescriptor(_class.prototype, "translatorAssignedAt", [_mobx.observable, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor341 = _applyDecoratedDescriptor(_class.prototype, "currentStreakStart", [_mobx.observable, _dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor342 = _applyDecoratedDescriptor(_class.prototype, "currentStreakEnd", [_mobx.observable, _dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor343 = _applyDecoratedDescriptor(_class.prototype, "site", [_mobx.observable, _dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor344 = _applyDecoratedDescriptor(_class.prototype, "bannerNotice", [_mobx.observable, _dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor345 = _applyDecoratedDescriptor(_class.prototype, "level", [_mobx.observable, _dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor346 = _applyDecoratedDescriptor(_class.prototype, "referrerOption", [_mobx.observable, _dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor347 = _applyDecoratedDescriptor(_class.prototype, "patreonUser", [_mobx.observable, _dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor348 = _applyDecoratedDescriptor(_class.prototype, "userGroups", [_mobx.observable, _dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor349 = _applyDecoratedDescriptor(_class.prototype, "targetLanguages", [_mobx.observable, _dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor350 = _applyDecoratedDescriptor(_class.prototype, "userPodcasts", [_mobx.observable, _dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor351 = _applyDecoratedDescriptor(_class.prototype, "defaultTargetLanguage", [_mobx.observable, _dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor352 = _applyDecoratedDescriptor(_class.prototype, "image", [_mobx.observable, _dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor353 = _applyDecoratedDescriptor(_class.prototype, "signedUpWithPromotion", [_mobx.observable, _dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor354 = _applyDecoratedDescriptor(_class.prototype, "membership", [_mobx.observable, _dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor355 = _applyDecoratedDescriptor(_class.prototype, "membershipType", [_mobx.observable, _dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor356 = _applyDecoratedDescriptor(_class.prototype, "membershipGroup", [_mobx.observable, _dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor357 = _applyDecoratedDescriptor(_class.prototype, "paymentMigration", [_mobx.observable, _dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor358 = _applyDecoratedDescriptor(_class.prototype, "privacySettings", [_mobx.observable, _dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor359 = _applyDecoratedDescriptor(_class.prototype, "currentLeague", [_mobx.observable, _dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor360 = _applyDecoratedDescriptor(_class.prototype, "lastUserLeague", [_mobx.observable, _dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "pro", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pro"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "useBritishEnglish", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "useBritishEnglish"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "streakRepairIsAvailable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "streakRepairIsAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "webReleaseUpToDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "webReleaseUpToDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetLanguagesWithXpCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetLanguagesWithXpCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "translatorRole", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "translatorRole"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "blockedTranslationInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "blockedTranslationInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trialTranslator", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "trialTranslator"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "leadTranslator", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "leadTranslator"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fullTranslator", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "fullTranslator"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "adminOrLeadTranslator", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "adminOrLeadTranslator"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "adminOrTranslator", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "adminOrTranslator"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "anyAdmin", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "anyAdmin"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAdminForSite", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "isAdminForSite"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showWebReleaseBanner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showWebReleaseBanner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "webVersionDownloadedWithoutRevision", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "webVersionDownloadedWithoutRevision"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rightToLeftLanguage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rightToLeftLanguage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentWebVersionWithoutRevision", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentWebVersionWithoutRevision"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canUpdateRecords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "canUpdateRecords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canDeleteRecords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "canDeleteRecords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideEnglishTranslations", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideEnglishTranslations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createdWithinLastWeek", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "createdWithinLastWeek"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "todaysDateMoment", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "todaysDateMoment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tomorrowsDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "tomorrowsDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tomorrowsDateMoment", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "tomorrowsDateMoment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languageName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languageName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registered", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "registered"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "premiumIsActive", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "premiumIsActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "membershipTypeId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "membershipTypeId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "distanceFromXpGoal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "distanceFromXpGoal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activePatreonMember", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "activePatreonMember"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "permanentPatreonMember", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "permanentPatreonMember"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasGroup", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userContentGroup", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userContentGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contentGroup", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "contentGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "easyGermanGroup", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "easyGermanGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "easyGermanGroupId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "easyGermanGroupId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "classroomGroup", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "classroomGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasContentGroup", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasContentGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasEasyGermanGroup", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasEasyGermanGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasClassroomGroup", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasClassroomGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasMembershipType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMembershipType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasPermanentGroupMembership", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasPermanentGroupMembership"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentUserGroup", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentUserGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentGroupMembership", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentGroupMembership"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentGroupMembershipType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentGroupMembershipType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasProMembershipOnSeedlang", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasProMembershipOnSeedlang"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasPermanentMembershipOnSeedlang", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasPermanentMembershipOnSeedlang"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasPermanentMembershipOnWhiteLabelSite", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasPermanentMembershipOnWhiteLabelSite"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMember", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMember"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasOneGroup", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasOneGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contentGroupId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "contentGroupId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "classroomGroupId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "classroomGroupId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "usesFacebookImage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "usesFacebookImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasLevel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasLevel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "levelName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "levelName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "levelAbbreviation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "levelAbbreviation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nativeSpeaker", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nativeSpeaker"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "title", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "title"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "badgeLevels", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "badgeLevels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "badgeLevelCounts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "badgeLevelCounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wasUiElementSeen", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "wasUiElementSeen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetLanguageById", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetLanguageById"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "designateUiElementAsSeen", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "designateUiElementAsSeen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "moduleIsContracted", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "moduleIsContracted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "inGroup", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "inGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "incrementVocabReviewCounts", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "incrementVocabReviewCounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "decrementVocabReviewCounts", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "decrementVocabReviewCounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currencySymbol", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currencySymbol"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckTypesOpened", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckTypesOpened"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentUserLeague", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentUserLeague"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentLeagueRank", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentLeagueRank"), _class.prototype), _class);
var _default = exports["default"] = User;